import {IBoxSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {IPageSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/Page';
import {ISurfaceStateSnapshot} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/SurfaceState';
import {BoxId} from '@mintdata/mint-kit/api/models/Identifiers';

export class BoxTreeUtil
{
    public static validateBoxTree(surfaceSnapshot:ISurfaceStateSnapshot):void
    {
        const start:number = performance.now();

        Object.values(surfaceSnapshot.pages).forEach((pageSnapshot:IPageSnapshot) =>
        {
            Object.values(pageSnapshot.artboard.allBoxes).forEach((boxSnapshot:IBoxSnapshot) =>
                {
                    const boxParentSnapshot:IBoxSnapshot = pageSnapshot.artboard.allBoxes[boxSnapshot.parent];

                    Object.values(pageSnapshot.artboard.allBoxes).forEach(
                        (curBoxSnapshot:IBoxSnapshot) =>
                        {
                            const index:number = curBoxSnapshot.children.findIndex(
                                (boxId:BoxId) => boxId === boxSnapshot.id
                            );

                            if( index !== -1 && (!boxParentSnapshot || curBoxSnapshot.id !== boxParentSnapshot.id) )
                                curBoxSnapshot.children.splice(index, 1);
                        }
                    );
                }
            );

            pageSnapshot.artboard.boxes = pageSnapshot.artboard.boxes.filter((value, index, self) => self.indexOf(value) === index);
        });

        const time:number = performance.now() - start;
        console.log('Surface shapshot validation took: ', time);
    }
}
